var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SafeAreaProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNativeSafeAreaContext = require("react-native-safe-area-context");
var _reactNative = require("react-native-web");
var _jsxRuntime = require("react/jsx-runtime");
var SafeAreaProvider = exports.SafeAreaProvider = function SafeAreaProvider(_ref) {
  var children = _ref.children;
  var _SafeAreaProviderStyles = {};
  if (_reactNative.Platform.OS === 'web') {
    _SafeAreaProviderStyles.position = 'static';
    _SafeAreaProviderStyles.zIndex = 'auto';
  }
  return (0, _jsxRuntime.jsx)(_reactNativeSafeAreaContext.SafeAreaProvider, {
    style: _SafeAreaProviderStyles,
    testID: "SafeAreaProvider",
    children: children
  });
};